import { render } from "./AudienceDetail.vue?vue&type=template&id=452a5d32&scoped=true"
import script from "./AudienceDetail.vue?vue&type=script&lang=js"
export * from "./AudienceDetail.vue?vue&type=script&lang=js"

import "./AudienceDetail.vue?vue&type=style&index=0&id=452a5d32&scoped=true&lang=css"
import "./AudienceDetail.vue?vue&type=style&index=1&id=452a5d32&lang=scss"

import exportComponent from "/Users/sandhiyabaskar/cx-portal/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-452a5d32"]])

export default __exports__